"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconBaggageFilled = function IconBaggageFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10,16h5a0,0,0,0,1,0,0V39a0,0,0,0,1,0,0H10a1,1,0,0,1-1-1V17A1,1,0,0,1,10,16Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35,16h5a1,1,0,0,1,1,1V38a1,1,0,0,1-1,1H35a0,0,0,0,1,0,0V16a0,0,0,0,1,0,0Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29,16V12a1,1,0,0,0-1-1H22a1,1,0,0,0-1,1v4H17V39H33V16Zm-6-2.5a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5V16H23Z",
    fill: color
  }));
};

IconBaggageFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconBaggageFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconBaggageFilled;
exports.default = _default;